
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2I7c2", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4aRua = parcelRequire("4aRua");


var $iDrrr = parcelRequire("iDrrr");


var $fhdGv = parcelRequire("fhdGv");

const $cc32d587f60855db$export$fb63530bed1f6351 = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { text: text, color: color, statusStyle: statusStyle, isBold: isBold } = t0;
    let t1;
    if ($[0] !== statusStyle || $[1] !== text) {
        t1 = statusStyle !== "mixedCase" && (0, $iDrrr.fg)("platform-dst-lozenge-tag-badge-visual-uplifts") ? text.toUpperCase() : text;
        $[0] = statusStyle;
        $[1] = text;
        $[2] = t1;
    } else t1 = $[2];
    const displayText = t1;
    let t2;
    if ($[3] !== color || $[4] !== displayText || $[5] !== isBold) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "span",
            testId: "status-component"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fhdGv.Status), {
            text: displayText,
            color: color,
            isBold: isBold
        }));
        $[3] = color;
        $[4] = displayText;
        $[5] = isBold;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
module.exports["StatusComponent"] = $cc32d587f60855db$export$fb63530bed1f6351;

});

parcelRegister("fhdGv", function(module, exports) {
/* Status.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lzgC6 = parcelRequire("lzgC6");


var $aCJyI = parcelRequire("aCJyI");


var $ftY7H = parcelRequire("ftY7H");


var $jDboD = parcelRequire("jDboD");


var $fB42n = parcelRequire("fB42n");

function $ba35a2a9fe36df5b$var$_defineProperty(e, r, t) {
    return (r = $ba35a2a9fe36df5b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ba35a2a9fe36df5b$var$_toPropertyKey(t) {
    var i = $ba35a2a9fe36df5b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ba35a2a9fe36df5b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ba35a2a9fe36df5b$var$MAX_WIDTH = 200; /**
                        * This is to account for a bug in android chromium and should be removed
                        * when the editor fixes its focus handling with respect to Status.
                        *
                        * See DSP-7701 for additional context.
                        */ 
const $ba35a2a9fe36df5b$var$inlineBlockStyles = null; // Bound the Lozenge to its parent while keeping short statuses content-sized.
const $ba35a2a9fe36df5b$var$constrainedToParentStyles = null; // eg. Version/4.0 Chrome/95.0.4638.50
const $ba35a2a9fe36df5b$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $ba35a2a9fe36df5b$var$StatusInternal extends (0, $cozmU.PureComponent) {
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold, isConstrainedToParent: isConstrainedToParent } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = (0, $fB42n.getLozengeAppearance)(color); // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ $cozmU.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $hekY6.default)([
                $ba35a2a9fe36df5b$var$isAndroidChromium && "_0ReY56US2K _3HdVfPey7F _3pS3pEt2nV",
                isConstrainedToParent && "_3iDTPbvbI6 _1EqgXlN91d",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onKeyDown: onClick ? this.handleKeyDown : undefined,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            tabIndex: onClick ? -1 : undefined,
            "data-node-type": "status",
            "data-color": (0, $fB42n.normalizeColor)(color),
            "data-style": style,
            role: role
        }, /*#__PURE__*/ $cozmU.createElement((0, $aCJyI.default), {
            appearance: appearance,
            maxWidth: $ba35a2a9fe36df5b$var$MAX_WIDTH,
            isBold: isBold
        }, text));
    }
    constructor(...args){
        super(...args);
        $ba35a2a9fe36df5b$var$_defineProperty(this, "hoverStartTime", 0);
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleMouseEnter", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleMouseLeave", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleKeyDown", (e)=>{
            const { onClick: onClick } = this.props;
            if (onClick && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                onClick(e);
            }
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleFocus", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleBlur", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
    }
}
$ba35a2a9fe36df5b$var$_defineProperty($ba35a2a9fe36df5b$var$StatusInternal, "displayName", 'StatusInternal');
const $ba35a2a9fe36df5b$export$96e9906d6d93a972 = (0, $lzgC6.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $ftY7H.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $ftY7H.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($ba35a2a9fe36df5b$var$StatusInternal);
module.exports["Status"] = $ba35a2a9fe36df5b$export$96e9906d6d93a972;

});

parcelRegister("ftY7H", function(module, exports) {
const $63d299faa378dc1a$export$d821aa4c8afb384e = 'fabric-elements';
const $63d299faa378dc1a$var$packageName = "platform-pkg";
const $63d299faa378dc1a$var$packageVersion = "0.0.0-use.local";
const $63d299faa378dc1a$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $63d299faa378dc1a$var$packageName;
        statusPayload.attributes.packageVersion = $63d299faa378dc1a$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($63d299faa378dc1a$export$d821aa4c8afb384e);
        return event;
    };
module.exports["createStatusAnalyticsAndFire"] = $63d299faa378dc1a$export$aa98853957f9f5aa;

});

parcelRegister("jDboD", function(module, exports) {
const $92130f7ce8b5e3de$export$7452d7062a4d0634 = 1000;
module.exports["ANALYTICS_HOVER_DELAY"] = $92130f7ce8b5e3de$export$7452d7062a4d0634;

});

parcelRegister("fB42n", function(module, exports) {

var $2pQiO = parcelRequire("2pQiO");

const $7f74d498381e9123$export$c6adb6b4e776f0d5 = [
    'neutral',
    'purple',
    'blue',
    'red',
    'yellow',
    'green'
];
const $7f74d498381e9123$export$ccac7cd631a2cc0f = [
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime — named `green` renders identically
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange — named `yellow` renders identically
    '#FDD0EC' // Magenta
];
const $7f74d498381e9123$export$acfdfc8c64e6747 = 'neutral';
const $7f74d498381e9123$export$645e10b5a408e986 = {
    neutral: 'neutral',
    purple: 'discovery',
    blue: 'information',
    red: 'danger',
    yellow: 'warning',
    green: 'success'
};
const $7f74d498381e9123$export$692279d423b4caab = "var(--ds-icon, #292A2E)";
const $7f74d498381e9123$export$56d196d2844d1ca1 = {
    neutral: {
        appearance: 'neutral',
        labelKey: 'neutralColor',
        swatch: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            borderColor: "var(--ds-border, #0B120E24)"
        }
    },
    blue: {
        appearance: 'accent-blue',
        labelKey: 'blueColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
            borderColor: "var(--ds-border-accent-blue-subtle, #8FB8F6)"
        }
    },
    '#B3F5FF': {
        appearance: 'accent-teal',
        labelKey: 'tealColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            borderColor: "var(--ds-border-accent-teal-subtle, #9DD9EE)"
        }
    },
    '#ABF5D1': {
        appearance: 'accent-green',
        labelKey: 'greenColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
            borderColor: "var(--ds-border-accent-green-subtle, #7EE2B8)"
        }
    },
    '#D3F1A7': {
        appearance: 'accent-lime',
        labelKey: 'limeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
            borderColor: "var(--ds-border-accent-lime-subtle, #B3DF72)"
        }
    },
    '#FFF0B3': {
        appearance: 'accent-yellow',
        labelKey: 'yellowColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderColor: "var(--ds-border-accent-yellow-subtle, #EED12B)"
        }
    },
    '#FCE4A6': {
        appearance: 'accent-orange',
        labelKey: 'orangeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
            borderColor: "var(--ds-border-accent-orange-subtle, #FBC828)"
        }
    },
    red: {
        appearance: 'accent-red',
        labelKey: 'redColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            borderColor: "var(--ds-border-accent-red-subtle, #FD9891)"
        }
    },
    '#FDD0EC': {
        appearance: 'accent-magenta',
        labelKey: 'magentaColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
            borderColor: "var(--ds-border-accent-magenta-subtle, #F797D2)"
        }
    },
    purple: {
        appearance: 'accent-purple',
        labelKey: 'purpleColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
            borderColor: "var(--ds-border-accent-purple-subtle, #D8A0F7)"
        }
    },
    yellow: {
        appearance: 'accent-orange',
        labelKey: 'yellowColor'
    },
    green: {
        appearance: 'accent-lime',
        labelKey: 'greenColor'
    }
};
const $7f74d498381e9123$export$d42d7c94d7629c23 = [
    'neutral',
    // Gray
    'blue',
    // Blue
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange
    'red',
    // Red
    '#FDD0EC',
    // Magenta
    'purple' // Purple
];
const $7f74d498381e9123$export$ee5a21461d1db57c = (color)=>$7f74d498381e9123$export$c6adb6b4e776f0d5.includes(color);
const $7f74d498381e9123$export$4cde5df63f53f473 = (color)=>color.startsWith('#') ? color.toUpperCase() : color;
const $7f74d498381e9123$var$specFor = (color)=>$7f74d498381e9123$export$56d196d2844d1ca1[$7f74d498381e9123$export$4cde5df63f53f473(color)];
const $7f74d498381e9123$export$4bc90a066e1dabc3 = (color)=>$7f74d498381e9123$var$specFor(color)?.labelKey ?? 'neutralColor';
const $7f74d498381e9123$export$13752f03fbf881b8 = (swatchValue, selectedColor)=>{
    if (!selectedColor) return false;
    if ($7f74d498381e9123$export$4cde5df63f53f473(swatchValue) === $7f74d498381e9123$export$4cde5df63f53f473(selectedColor)) return true;
    // A swatch also counts as selected when it renders the same hue under a different
    // id — legacy named `green`/`yellow` share the Lime/Orange swatches. Unknown values
    // have no spec, so they never collide on the neutral fallback.
    const swatchAppearance = $7f74d498381e9123$var$specFor(swatchValue)?.appearance;
    return swatchAppearance !== undefined && swatchAppearance === $7f74d498381e9123$var$specFor(selectedColor)?.appearance;
};
const $7f74d498381e9123$export$4d9e331cafeacb9d = (color)=>{
    const isUpdateStatusColorsEnabled = (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_update_status_colors', 'isEnabled', false) || (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_update_status_colors_jira', 'isEnabled', false);
    // Named colours are recoloured only by the experiment, so they must never reach the
    // hex mapping below.
    if ($7f74d498381e9123$export$ee5a21461d1db57c(color)) return isUpdateStatusColorsEnabled ? $7f74d498381e9123$export$56d196d2844d1ca1[color].appearance : $7f74d498381e9123$export$645e10b5a408e986[color];
    return $7f74d498381e9123$var$specFor(color)?.appearance ?? $7f74d498381e9123$export$acfdfc8c64e6747;
};
module.exports["SWATCH_ICON_COLOR"] = $7f74d498381e9123$export$692279d423b4caab;
module.exports["COLORS"] = $7f74d498381e9123$export$56d196d2844d1ca1;
module.exports["PICKER_SWATCHES"] = $7f74d498381e9123$export$d42d7c94d7629c23;
module.exports["normalizeColor"] = $7f74d498381e9123$export$4cde5df63f53f473;
module.exports["getColorLabelKey"] = $7f74d498381e9123$export$4bc90a066e1dabc3;
module.exports["isSwatchSelected"] = $7f74d498381e9123$export$13752f03fbf881b8;
module.exports["getLozengeAppearance"] = $7f74d498381e9123$export$4d9e331cafeacb9d;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== onStartMotion || $[9] !== requestAnimationFrame || $[10] !== setTimeout) {
        t3 = ()=>{
            if (!element) return;
            if ((0, $jlWUB.isReducedMotion)()) {
                onFinishMotion?.();
                return;
            }
            if (!prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            onStartMotion?.();
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = onStartMotion;
        $[9] = requestAnimationFrame;
        $[10] = setTimeout;
        $[11] = t3;
    } else t3 = $[11];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[12] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[12] = setElementRef;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if (!element) return;
        if ((0, $jlWUB.isReducedMotion)()) {
            // No motion will ever run, so the element is already at its final dimensions.
            onFinishMotion?.();
            return;
        }
        if (!prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        // Any in-flight transition styles have been cleared and the next ones haven't been applied
        // yet, so the element is at the natural layout it will settle at.
        onStartMotion?.();
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});


//# sourceMappingURL=StatusComponent.ce207394.js.map
